import SoftOffer from "../../entities/campaigns/offers/SoftOffer";
import { ISoftOfferResponse } from "../../entities/campaigns/types";

export default class SoftOfferFactory {

  static create(softOffer: ISoftOfferResponse): SoftOffer {
    return new SoftOffer(
      parseInt(softOffer.id),
      parseInt(softOffer.offerId),
      softOffer.optionName,
      softOffer.saveDesk,
      softOffer.p2p,
      softOffer.upsell,
      softOffer.featuredPackages,
      softOffer.unfeaturedPackages,
      softOffer.p2pDj,
      softOffer.desc,
      softOffer.generalInfo
    );
  }

}
